import React, { useCallback, useMemo } from 'react';
import VoxelAutocomplete, { GenericOption, VoxelAutocompleteProps } from './VoxelAutocomplete';

export interface VoxelSelectProps
  extends Omit<VoxelAutocompleteProps, 'setSelectedOptions' | 'selectedOptionValues'> {
  selectedOptionValue?: any;
  setSelectedOption: (option: GenericSelectOption) => void;
  maxHeightOptions?: number;
  hideDisabledOptions?: boolean;
}

export interface GenericSelectOption extends GenericOption {}

export const VoxelSelect: React.FC<VoxelSelectProps> = ({
  selectedOptionValue,
  setSelectedOption,
  emptyAllowed = false,
  maxHeightOptions = 500,
  hideSearch = true,
  hideDisabledOptions,
  inputWidthClass = 'w-full',
  options,
  ...props
}) => {
  const selectedOptionValues = useMemo(() => [selectedOptionValue], [selectedOptionValue]);

  const setSelectedOptions = useCallback(
    (options: GenericOption[]) => setSelectedOption(options[0]),
    [setSelectedOption]
  );

  const filteredOptions = useMemo(
    () => (!hideDisabledOptions ? options : options?.filter((opt) => !opt?.disabled)),
    [options]
  );

  return (
    <VoxelAutocomplete
      emptyAllowed={emptyAllowed}
      hideSearch={hideSearch}
      selectedOptionValues={selectedOptionValues}
      setSelectedOptions={setSelectedOptions}
      maxHeightOptions={maxHeightOptions}
      inputWidthClass={inputWidthClass}
      options={filteredOptions}
      {...props}
    />
  );
};

export default VoxelSelect;
